export default "__VITE_ASSET__aa06b23e__"